import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import useFetchFedwireFundTransaction from '@/hooks/useApi/useFetchFedwireFundTransaction';
import FedwireFundingTransactionInfo from './FedwireFundingTransactionInfo';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

type TransactionProps = {
  TransactionID: string;
  Notes: string;
};
type FC = FunctionComponent<TransactionProps>;

const FedwireFundingContainer: FC = (props: TransactionProps) => {
  const { TransactionID, Notes } = props;
  const { userSettings } = useUserSettingsProvider();
  const [FedwireFundTransaction, getFedwireFundTransaction] = useFetchFedwireFundTransaction({
    bearer: '',
  });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.FedwireTransactionResponse>();

  useEffect(() => {
    getFedwireFundTransaction({ TransactionID, Timezone: userSettings.timezone });
  }, [currentTransactionId]);

  useEffect(() => {
    if (FedwireFundTransaction && FedwireFundTransaction.Success) {
      setTransaction(FedwireFundTransaction);
    }
  }, [FedwireFundTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return <div>{transaction && <FedwireFundingTransactionInfo transaction={transaction} Notes={Notes} />}</div>;
};

export default FedwireFundingContainer;
